import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { LoggingService } from '../../shared/services/core/logging.service';
import { TicketQuery } from '../state/ticket.query';

/**
 * @deprecated use ticketTransferGuard instead 
 */
@Injectable({
  providedIn: 'root'
})
export class TicketTransferGuard  {
  constructor(private router: Router, private ticketQuery: TicketQuery, private logService: LoggingService) {}

  canActivate(): boolean {
    if (!(this.ticketQuery.getCount(ticket => ticket.selected) > 0)) {
      this.logService.info('No tickets selected, redirecting to the home page.');
      this.router.navigate(['/ticketTransfer']);
      return false;
    } else {
      return true;
    }
  }
}

export function ticketTransferGuard(redirect: string = '/ticketTransfer/tickets'): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const router: Router = inject(Router);
    const ticketQuery: TicketQuery = inject(TicketQuery);
    const logService: LoggingService = inject(LoggingService);
    const gameNumber = route.paramMap.get('gameNumber');

    if (!(ticketQuery.getCount(ticket => ticket.selected) > 0)) {
      logService.info('No tickets selected, redirecting to the home page.');
      router.navigate([redirect, gameNumber]);
      return false;
    } else {
      return true;
    }
  };
}
